'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import {
  flexItemStyles,
  layoutStyles,
  marginStyles,
  maxWidthStyle as maxWidth,
  minWidthStyle as minWidth,
  widthStyle as width
} from '../../_support'

// lib
import { themedView } from '../../_support'

/* -----------------------------------------------------------------------------
 * FieldContainer
 * -------------------------------------------------------------------------- */

const FieldContainer = themedView(
  'FieldContainer',
  flexItemStyles,
  layoutStyles,
  marginStyles,
  width,
  maxWidth,
  minWidth
)

export type FieldContainerProps = React.ComponentProps<typeof FieldContainer>

export default FieldContainer
